const $ = jQuery.noConflict();
'use strict';

$(function() {

	const contact = {
		strCF7Holder: '.js-cf7-holder',
		strForm: '.wpcf7-form',
		strTriggerURL: '#wpcf7-f17-o1',
		classSent: 'form-is-sent',
		classInvalid: 'invalid',

		init: function() {
			this.afterFormSubmit();
			this.closeThankYouPopup();
			this.closeMenuOnOutsideContainerClickContact();
			this.closeContactPopupOnEsc();
			$('form.wpcf7-form').on('submit', function() {
				const form = $(this);
				const button = form.find('input[type=submit]');
				const currentVal = button.val();

				button.attr('data-value', currentVal);

				button.prop('disabled', true);

			});
			$('.wpcf7').on('wpcf7invalid', function() {
				$('form.wpcf7-form').find('input[type=submit]').prop('disabled', false);
			});
			$('.wpcf7').on('wpcf7mailsent', function() {
				$('form.wpcf7-form').find('input[type=submit]').prop('disabled', false);
			});
		},

		afterFormSubmit: (formHolder = '.js-cf7-holder', sentClass = 'form-is-sent') => {

			document.addEventListener('wpcf7mailsent', (e) => {

				const formId = e.detail.id;
				$('.cf7-holder__popup').addClass('is-active');
				$('body').addClass('prevent-scroller');
				$('.wpcf7 form').find('select').each(function() {
					$(this).val(null).trigger('change');
				});

				$(formId).parents(formHolder).addClass(sentClass);

				setTimeout(() => {
					$(formHolder).removeClass(sentClass);
					$('.cf7-holder__popup').removeClass('is-active');
					$('body').removeClass('prevent-scroller');
				}, 3000);
			}, false);
		},

		closeThankYouPopup: function() {
			$('.js-contact-us__popup-close').on('click', function() {
				$('.cf7-holder__popup').removeClass('is-active');
				$('.cf7-holder').removeClass('is-active');
				$('body').removeClass('prevent-scroller');
			});
		},

		closeMenuOnOutsideContainerClickContact: function() {
			$('body').on('mouseup', function(e) {
				e.preventDefault();
				if ($('.cf7-holder__popup').hasClass('is-active') && !$('.contact-us__popup-inner').is(e.target) && $('.contact-us__popup-inner').has(e.target).length === 0 && !$('.js-contact-us__popup-close').is(e.target)) {
					$('.cf7-holder__popup').removeClass('is-active');
					$('body').removeClass('prevent-scroller');
				}
			});
		},

		closeContactPopupOnEsc: function() {
			$(document).on('keyup', function(e) {
				if (e.keyCode === 27) {
					$('.cf7-holder__popup').removeClass('is-active');
					$('body').removeClass('prevent-scroller');
				}
			});
		},
	};

	contact.init();
});
